import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { message: String }

  confirm(event) {
    if (!confirm(this.messageValue || "Sind Sie sicher?")) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return false
    }
  }
}